import { useState } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import { useApp } from "../context/AppContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const BG = "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxtZWNoYW5pYyUyMHdvcmtpbmd8ZW58MHx8fHwxNzg4MDkyMzYzfDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { user, setUser, t, lang, setLang } = useApp();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="flex-1 flex items-center justify-center px-6 bg-white">
        <div className="w-full max-w-md">
          <div className="flex items-center gap-3 mb-10">
            <img src="/brand-logo.jpg" alt="ClearRoute Auto Glass" data-testid="login-logo"
              className="h-14 w-20 rounded-lg object-contain border border-slate-200 p-1" />
            <div>
              <div className="font-heading font-extrabold text-xl text-slate-900">{t("loginTitle")}</div>
              <div className="text-xs uppercase tracking-widest text-slate-500">{t("loginSubtitle")}</div>
            </div>
          </div>
          <h1 className="font-heading text-3xl font-bold text-slate-900 mb-2">{t("welcome")}</h1>
          <p className="text-slate-500 text-sm mb-8">{t("loginSubtitle")}</p>
          <form onSubmit={submit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="email">{t("email")}</Label>
              <Input
                id="email" data-testid="login-email-input" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} className="h-11" placeholder="you@company.com"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">{t("password")}</Label>
              <Input
                id="password" data-testid="login-password-input" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)} className="h-11" placeholder="••••••••"
              />
            </div>
            <Button
              data-testid="login-submit-button" type="submit" disabled={loading}
              className="w-full h-11 bg-sky-600 hover:bg-sky-700 text-white font-semibold"
            >
              {loading ? "..." : t("login")}
            </Button>
          </form>
          <div className="mt-8 flex gap-2">
            <button data-testid="login-lang-en" onClick={() => setLang("en")}
              className={`text-xs font-semibold px-3 py-1.5 rounded-md border ${lang === "en" ? "bg-slate-900 text-white border-slate-900" : "border-slate-200 text-slate-500"}`}>EN</button>
            <button data-testid="login-lang-pt" onClick={() => setLang("pt")}
              className={`text-xs font-semibold px-3 py-1.5 rounded-md border ${lang === "pt" ? "bg-slate-900 text-white border-slate-900" : "border-slate-200 text-slate-500"}`}>PT</button>
          </div>
        </div>
      </div>
      <div className="hidden lg:block flex-1 relative">
        <img src={BG} alt="Auto glass technician" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-slate-900/70" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <h2 className="font-heading text-3xl font-bold mb-3">Customers. Orders. Cash flow. Receipts.</h2>
          <p className="text-slate-300">Everything your shop needs, in one place.</p>
        </div>
      </div>
    </div>
  );
}
